export default __webpack_public_path__ + "assets/models/3f2d2eff74be04038b3a928c8fe7eb7a.glb";